module.exports = __webpack_public_path__ + "img/gallery.c0b32208.png";